import moment from 'moment';

export type WeekGroup = {
  dates: string[];
};

/**
 * Groups the flight's dates by ISO calendar week (Monday-Sunday), using
 * `isoWeekYear()` + `isoWeek()` so weeks are grouped correctly across year
 * boundaries. The first and last groups are naturally partial when the
 * flight doesn't start on a Monday or end on a Sunday.
 */
export function groupDatesIntoWeeks(dates: string[]): WeekGroup[] {
  const groups: WeekGroup[] = [];
  let lastWeekKey: string | null = null;

  for (const date of dates) {
    const current = moment.utc(date);
    const weekKey = `${current.isoWeekYear()}-${current.isoWeek()}`;

    if (weekKey === lastWeekKey) {
      groups[groups.length - 1].dates.push(date);
    } else {
      groups.push({ dates: [date] });
      lastWeekKey = weekKey;
    }
  }

  return groups;
}
